/**
 * Copyright © 2026 OwnersTable Inc. All rights reserved.
 * This source code is proprietary and confidential.
 * Unauthorized copying or distribution is strictly prohibited.
 */

import { FormControlLabel, IconButton, styled } from "@mui/material";

export const StyledIconButton = styled(IconButton)({
  border: '1px solid #d4d4d8',
  borderRadius: '8px',
  height: '40px',
  width: '40px',
  marginBottom: '1px',
  alignSelf: 'end',
})

export const StyledFormControlLabel = styled(FormControlLabel)({
  marginRight: 0,
  marginLeft: 0,
  alignSelf: 'end',
  minHeight: '40px',
  whiteSpace: 'nowrap',
  '& .MuiFormControlLabel-label': {
    fontSize: '14px',
    color: '#3f3f46',
  },
})

